import { render, staticRenderFns } from "./DayRaceList.vue?vue&type=template&id=47c574e2&scoped=true"
import script from "./DayRaceList.vue?vue&type=script&lang=js"
export * from "./DayRaceList.vue?vue&type=script&lang=js"
import style0 from "./DayRaceList.vue?vue&type=style&index=0&id=47c574e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c574e2",
  null
  
)

export default component.exports